<template>
  <nav class="navbar">
    <!-- Logo -->
    <div class="header-container1">
      <a href="#"><img src="/Images/Brewtopia-Logo-Simplified-tr.png" alt="Brewtopia Logo" /></a>
    </div>

    <!-- Desktop Nav -->
    <div class="header-container2 desktop-only">
      <ul class="nav-list">
        <li><a href="#">Home</a></li>
        <li><a href="#Menu">Menu</a></li>
        <li><a href="#About">About Us</a></li>
        <li><a href="#Contact">Contact</a></li>
      </ul>
    </div>

    <!-- Desktop CTA -->
    <div class="header-container3 desktop-only">
      <a href="#form"><div class="CTA-header">Book a Table</div></a>
    </div>

    <!-- Hamburger -->
    <button class="hamburger mobile-only" @click="toggleMenu">
      <span :class="{ active: menuOpen }"></span>
      <span :class="{ active: menuOpen }"></span>
      <span :class="{ active: menuOpen }"></span>
    </button>

    <!-- Mobile Menu -->
    <transition name="fade-slide">
      <div v-if="menuOpen" class="mobile-menu">
        <div class="mobile-links">
          <a href="#" @click="closeMenu">Home</a>
          <hr />
          <a href="#Menu" @click="closeMenu">Menu</a>
          <hr />
          <a href="#About" @click="closeMenu">About Us</a>
          <hr />
          <a href="#Contact" @click="closeMenu">Contact</a>
        </div>

        <div class="mobile-cta-wrapper">
          <a href="#form"><button class="mobile-cta">Reserve a Table</button></a>
        </div>
      </div>
    </transition>
  </nav>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      menuOpen: false,
    }
  },
  methods: {
      closeMenu() {
    this.menuOpen = false
    document.body.style.overflow = ''
    document.body.style.overflowX = ''
    document.documentElement.style.overflowX = ''
  },
  toggleMenu() {
  this.menuOpen = !this.menuOpen
  if (this.menuOpen) {
    document.body.style.overflow = 'hidden'
    document.body.style.overflowX = 'hidden' // أضف هذا
    document.documentElement.style.overflowX = 'hidden' // أضف هذا
  } else {
    document.body.style.overflow = ''
    document.body.style.overflowX = ''
    document.documentElement.style.overflowX = ''
  }
}
  },
}
</script>

<style scoped>

* {
  box-sizing: border-box;
}

/* Navbar */
.navbar {
  width: 100%;
  height: 4.5rem;
  padding: 1rem 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
    left: 0; /* أضف هذا */
  right: 0;
  z-index: 100;
  background: lab(95.95% -4.19 12.04 / 0.45);
  backdrop-filter: blur(14px);
  border-bottom: 1px solid #6f4e37;
    box-sizing: border-box;
}

/* Logo */
.header-container1 {
  width: 11rem;
}
.header-container1 img {
  width: 100%;
}

/* Desktop Nav */
.nav-list {
  display: flex;
  gap: 2.2rem;
}
a {
  text-decoration: none;
  font-weight: 600;
  color: #6f4e37;
  transition: color 0.6s ease-in-out;
}
a:hover {
  color: #d4a574;
}

/* CTA */
.CTA-header {
  padding: 10px 1.8rem;
  background: #d4a574;
  border-radius: 10px;
  font-weight: 600;
  color: #a64500;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
}
.CTA-header:hover {
  background: rgba(195, 142, 93, 0.82);
  color: #a64500c8;
}
li{
  list-style: none;
}
/* Hamburger */
.hamburger {
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.hamburger span {
  width: 26px;
  height: 2px;
  background: #6f4e37;
  transition: all 0.4s ease-in-out;
}
.hamburger span.active:nth-child(1) {
  transform: rotate(45deg) translateY(8px);
}
.hamburger span.active:nth-child(2) {
  opacity: 0;
}
.hamburger span.active:nth-child(3) {
  transform: rotate(-45deg) translateY(-8px);
}

/* Mobile Menu */
.mobile-menu {
  position: fixed;
  top: 4.5rem;
  left: 0;
  right: 0; /* أضف هذا */
  width: 100vw; /* بدلاً من 100% */
  max-width: 100%; /* أضف هذا */
  background: #fff8dce7;
  backdrop-filter: blur(18px);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1.5rem 0 2rem;
  box-sizing: border-box; /* أضف هذا */
}


/* Mobile Links */
.mobile-links {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mobile-links a {
  padding: 0.75rem 0;
  font-size: 1.05rem;
}

/* HR between links */
.mobile-links hr {
  width: 40%;
  border: none;
  border-top: 1px solid rgba(111, 78, 55, 0.25);
  margin: 0;
}

/* Mobile CTA */
.mobile-cta-wrapper {
  margin-top: 1.5rem;
}
.mobile-cta {
  background: transparent;
  border: 1px solid #d4a574;
  color: #8b4513;
  padding: 0.75rem 2rem;
  border-radius: 999px;
  font-weight: 500;
  cursor: pointer;
}

/* Animations */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* Responsive */
.desktop-only {
  display: flex;
}
.mobile-only {
  display: none;
}

@media (max-width: 1024px) {
  .desktop-only {
    display: none;
  }
  .mobile-only {
    display: flex;
  }
  
}
</style>
